export interface MSClarityAnalyticsTrackerConfiguration {
  projectId: string;
}
